<template>
  <div class="qualification-page" v-loading="loading">
    <el-page-header @back="$router.back()" content="资质文件查看与下载" />

    <el-card class="info-card" shadow="never">
      <div slot="header">
        <span>设备信息</span>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="设备名称">{{ detail.name }}</el-descriptions-item>
        <el-descriptions-item label="规格型号">{{ detail.model }}</el-descriptions-item>
        <el-descriptions-item label="出厂编号">{{ detail.factory_no }}</el-descriptions-item>
        <el-descriptions-item label="科室">{{ detail.department }}</el-descriptions-item>
        <el-descriptions-item label="资质有效期至">{{ detail.expire_date }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="pdf-card" shadow="never" v-if="detail.qualification_url">
      <div slot="header" class="pdf-header">
        <span>资质 PDF 预览</span>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="handleDownload"
        >
          下载资质 PDF
        </el-button>
      </div>
      <iframe
        v-if="pdfUrl"
        :src="pdfUrl"
        style="width: 100%; height: 680px; border: none"
        frameborder="0"
      ></iframe>
    </el-card>

    <el-empty v-else description="暂无资质文件" style="margin-top: 40px" />
  </div>
</template>

<script>
import equipmentApi from '../api/equipment'

export default {
  name: 'QualificationDownload',
  data() {
    return {
      detail: {},
      loading: false,
    }
  },
  computed: {
    pdfUrl() {
      // 浏览器在线预览 PDF：加 #toolbar=1 显示下载/打印工具条
      return this.detail.qualification_url
        ? `${this.detail.qualification_url}#toolbar=1`
        : null
    },
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      try {
        const res = await equipmentApi.detail(this.$route.params.id)
        this.detail = res.data
        if (!res.data.qualification_url) {
          this.$message.warning('该设备未上传资质 PDF')
        }
      } catch (e) {
        this.$message.error('加载设备详情失败')
      } finally {
        this.loading = false
      }
    },
    handleDownload() {
      const url = this.detail.qualification_url
      if (!url) {
        this.$message.warning('暂无资质文件可下载')
        return
      }
      // 通过构造 <a download> 触发浏览器下载；绝对 URL 来自后端，同源可直接下载
      const link = document.createElement('a')
      link.href = url
      link.download = `${this.detail.name || '设备'}_资质.pdf`
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style scoped>
.qualification-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}
.info-card {
  margin-top: 20px;
}
.pdf-card {
  margin-top: 20px;
}
.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
